import React, { useContext, useEffect, useState } from 'react'
import axios from "axios"
import { useParams } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Cookies from 'js-cookie';
import instance from '../Config/AxiosConfig';
import Swal from 'sweetalert2';
function TopBar() {
    const { user, isAuth } = useContext(AuthContext)
    const handleLogout = () => {
        Cookies.remove('token');
        Cookies.remove('response');
        Cookies.remove('userId')
        localStorage.removeItem('formNumber')
        localStorage.removeItem('userId')
        window.location.href = '/';
    };
    //accepte request
    const [accept, setAccept] = useState('')
    const [decline, setDecline] = useState('')
    const handleAccept = async (id) => {
        const token = Cookies.get('token');
        let data = new FormData();
        data.append('id', id);
        try {
            const response = await instance.post('connectionRequests/accept', data, token)
            setAccept(response)

        }
        catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }
    }
    const handleDecline = async (id) => {
        const token = Cookies.get('token');
        let data = new FormData();
        data.append('id', id);
        try {
            const response = await instance.post('connectionRequests/decline', data, token)
            setDecline(response)
        }
        catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }
    }
    const [notif, setNotif] = useState([]);

    // useEffect(() => {
    //     const token = Cookies.get('token');
    //     instance.get("/connectionRequests/getAll", token)
    //         .then(response => {
    //             console.log(response.data, 'request');
    //             setNotif(response.data);
    //         })
    //         .catch(error => {
    //             console.error('Erreur lors de la récupération des Notif:', error);
    //         });
    // }, [accept, decline])
    console.log(isAuth, "isAuthisAuthisAuthisAuthisAuth");
    // const requestReceived = isAuth && isAuth ? (notif.filter(x => x.receiver.id === user.id)) : [];
    // const requestReceived = isAuth && Array.isArray(notif) ? notif.filter(x => x.receiver.id === user.id) : [];
    const [notifications, setNotifications] = useState([]);
    const [hasNewNotifications, setHasNewNotifications] = useState(false);
    useEffect(() => {
        // Fonction pour obtenir les notifications non alertées et non vues
        const getNotifications = async () => {
            const token = Cookies.get('token');
            try {
                const response = await
                    instance.get("/notifications/getAll", token)
                const allNotifications = response.data;
                console.log(response.data, "response.data");
                setNotifications(allNotifications)
                // Filtrer les notifications non alertées et non vues
                // const newNotifications = allNotifications.filter(
                //     (notification) => notification.alert || notification.vue
                // );
                // console.log(newNotifications, "newNotificationsnewNotifications");

                // Si des notifications non alertées ou non vues existent, mettre à jour l'état
                // setNotifications(newNotifications);
                // setHasNewNotifications(newNotifications);
            } catch (error) {
                console.error('Erreur lors de la récupération des notifications:', error);
            }
        };
        getNotifications();
    }, [accept, decline]);
    return (
        <>
            <header className="navbar-light fixed-top header-static bg-mode">
                {/* Logo Nav START */}
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        {/* Logo START */}
                        <a className="navbar-brand" href="/">
                            <img className="light-mode-item navbar-brand-item" src="../../assets/images/bg/05.png" alt="logo" />
                        </a>
                        {/* Logo END */}
                        {/* Responsive navbar toggler */}
                        <button className="navbar-toggler ms-auto icon-md btn btn-light p-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-animation">
                                <span />
                                <span />
                                <span />
                            </span>
                        </button>
                        {/* Main navbar START */}
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                     {/* Nav Search END */}
                            <ul className="navbar-nav navbar-nav-scroll ms-auto">
                                <li className="nav-item">
                                    <a className="nav-link" href="/">Home</a>
                                </li>
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="/myprofill">About</a>
                                </li> */}
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="/">contact</a>
                                </li> */}
                            </ul>
                            {!isAuth &&
                                <ul className="nav flex-nowrap align-items-center ms-sm-3 list-unstyled">
                                    <li className="nav-item ms-2">
                                        <Link to="/signin"><button type="submit" class="btn btn-primary mb-0">Login</button>
                                        </Link>
                                        <Link to="/signup"  ><button type="submit" class="btn btn-primary mb-0 ms-2">register</button>
                                        </Link>
                                    </li>
                                </ul>
                            }
                        </div>
                        {isAuth &&
                            <ul className="nav flex-nowrap align-items-center ms-sm-3 list-unstyled">
                                {/* <li className="nav-item ms-2">
                                    <a className="nav-link bg-light icon-md btn btn-light p-0" href="/messaging">
                                        <i className="bi bi-chat-left-text-fill fs-6"> </i>
                                    </a>
                                </li> */}

                                <li className="nav-item dropdown ms-2">
                                    <a className="nav-link bg-light icon-md btn btn-light p-0" href="#" id="notifDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                        {hasNewNotifications.length > 0 && <span className="badge-notif animation-blink" />}
                                        <i className="bi bi-bell-fill fs-6"> </i>
                                    </a>
                                    <div className="dropdown-menu dropdown-animation dropdown-menu-end dropdown-menu-size-md p-0 shadow-lg border-0" aria-labelledby="notifDropdown">
                                        <div className="card">
                                            <div className="card-header d-flex justify-content-between align-items-center">
                                                <h6 className="m-0">Notifications </h6>
                                                {/* <a className="small" href="#">Clear all</a> */}
                                            </div>
                                            <div className="card-body p-0">
                                                <ul className="list-group list-group-flush list-unstyled p-2" style={{ height: "500px", overflowY: "scroll" }}>
                                                {Array.isArray(notifications) && notifications.length !== 0 ?
                                                        notifications.map((notif, i) => {
                                                            return (
                                                                <div>
                                                                    <li key={i}>
                                                                        <div className="list-group-item list-group-item-action rounded badge-unread d-flex border-0 mb-1 p-3">
                                                                            <div className="avatar text-center d-none d-sm-inline-block">
                                                                                <img className="avatar-img rounded-circle" src={notif.senderAccount.profilePicture ? notif.senderAccount.profilePicture : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNL_ZnOTpXSvhf1UaK7beHey2BX42U6solRA&s"} alt="" />
                                                                            </div>
                                                                            <div className="ms-sm-3">
                                                                                <div className=" d-flex flex-rox">
                                                                                    <p className="small mb-2"><b>{notif.senderAccount.firstName} {notif.senderAccount.lastName}</b><br />


                                                                                    </p>
                                                                                    <p className="small ms-3 text-nowrap">
                                                                                        {notif.date.slice(0, 10)}</p>
                                                                                </div>
                                                                                <div>
                                                                                    {notif.type === "connectionRequest" && "sent you a connection request"}
                                                                                    {notif.type === "new_project" && <>
                                                                                        {`added you to a new project titled ${notif.relatif.title}. `}
                                                                                        <a href={`/projectdetails/${notif.relatif.id}`} rel="noopener noreferrer">

                                                                                            Check it out for more details!
                                                                                        </a>
                                                                                    </>}
                                                                                    {notif.type === "acceptConnectionRequest" && 'accepted your connection request.'}
                                                                                </div>
                                                                                {notif.type === "connectionRequest" &&
                                                                                    <div className="d-flex">
                                                                                        <button onClick={() => handleAccept(notif.senderAccount.id)} className="btn btn-sm py-1 btn-primary me-2">Accept </button>
                                                                                        <button onClick={() => handleDecline(notif.senderAccount.id)} className="btn btn-sm py-1 btn-danger-soft">Decline </button>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        <h5 className='bold text-center my-3'>No request received </h5>
                                                    }
                                                </ul>
                                            </div>
                                            {/* <div className="card-footer text-center">
                                                <a href="#" className="btn btn-sm btn-primary-soft">See all incoming activity</a>
                                            </div> */}
                                        </div>
                                    </div>
                                </li>
                       <li className="nav-item ms-2 dropdown">
                                    <a className="nav-link btn icon-md p-0" href="#" id="profileDropdown" role="button" data-bs-auto-close="outside" data-bs-display="static" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img className="avatar-img rounded-2" src={user.profilePicture} alt />
                                    </a>

                                    <ul className="dropdown-menu dropdown-animation dropdown-menu-end pt-3 small me-md-n3" aria-labelledby="profileDropdown">
                                        <li className="px-3">
                                            <div className="d-flex align-items-center position-relative">
                                                {/* Avatar */}
                                                <div className="avatar me-3">
                                                    <img className="avatar-img rounded-circle" src={user && user.profilePicture} alt="avatar" />
                                                </div>
                                                <div>
                                                    <a className="h6 stretched-link" href="#">{user.firstName} {user.lastName}</a>
                                                </div>
                                            </div>
                                            <a className="dropdown-item btn btn-primary-soft btn-sm my-2 text-center" href={"/myprofil/" + user.id}>View profile</a>
                                        </li>
                                             <li onClick={handleLogout} style={{ cursor: "pointer" }}>
                                            <span className="dropdown-item bg-danger-soft-hover">
                                                <i className="bi bi-power fa-fw me-2" />Sign Out
                                            </span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        }
                    </div>
                </nav>
            
            </header>
        </>
    )
}
export default TopBar